import React from 'react';

interface NmSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

/** Neumorphic select field — matches NmInput styling. */
export function NmSelect({ label, className = '', id, children, ...props }: NmSelectProps) {
  const selectId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className={`nm-select-wrap ${className}`.trim()}>
      {label && (
        <label htmlFor={selectId} className="nm-input-label">
          {label}
        </label>
      )}
      <select id={selectId} className="nm-select-field" {...props}>
        {children}
      </select>
    </div>
  );
}
